export default __webpack_public_path__ + "static/media/tictactoe.d9cf9668.png";